import React, { Component, Fragment } from 'react';
import {
    withRouter
} from 'react-router-dom';
import lpApp from '../../app/lp_app';
import { TitleShimmer, ParagraphShimmer } from './../misc/shimmer';

import { connect } from 'react-redux';
import { LP_STATE_WIZARD, setAppState } from '../../redux/actions/app_state';
import { lpPattern, P_BACK } from '../../tracking/pattern_detector';
import writeHistory from '../../logic/history';
import { HARCODED_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';
import LpHeader from './header';
import CePackChoiceTwoNext from './ce-checkout-step-two-next';


class CheckoutWrapper extends Component {
    constructor(props) {
        super(props);
        lpApp.mainCheckout(
          this.props.match.params.name,
          this.props.match.params.id ? this.props.match.params.id : ''
        );
    }

    componentWillMount(){
      if(!this.props.togglepack || !(HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1)) {
        this.props.history.push(`/contrats/${this.props.match.params.name}/${this.props.match.params.id}/paiement`)
      }
    }

    render () {
        return ( this.props.togglepack ?
            <div>
                <div className="lp-checkout">
                  <LpHeader />
                  <CePackChoiceTwoNext />
                </div>
            </div>
        : null);
    }
}

const mapStateToProps = state => ({
    togglepack: state.checkout_operations.togglepack
});

const mapDispatchToProps = dispatch => ({
    goBack: () => {
        dispatch(setAppState(LP_STATE_WIZARD));
        // #event
        lpevents.track('Modifier mon document', {});
        lpPattern.trackLastAction(P_BACK);
        lpPattern.sendAndResetTracker();
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckoutWrapper));



// WEBPACK FOOTER //
// ./src/components/buy/checkout_wrapper.js